import { request } from '../../helpers'

export default {
  async retrieveFeatureFlagValue(id) {
    if (!id) {
      console.warn('API: retrieveFeatureFlagValue: id is not defined!')
      return
    }
    return (await request({ url: `feature_flags/${id}/status` })).data?.active
  },
  async updateFeatureFlagValue(id, value = null) {
    if (!id) {
      console.warn('API: updateFeatureFlagValue: id is not defined!')
      return
    }

    return (
      await request({
        method: 'PUT',
        url: `feature_flags/${id}/choice`,
        data: {
          enabled: value,
        },
      })
    ).data
  },
}
